module.exports = __webpack_public_path__ + "img/car_3.7177b8eb.png";